export default requester => {
    return {
        /**
         * Get storage library.
         *
         * @param  {object}  params
         * @return {object}
         */
        findAll(platformId, params = {}) {
            return requester.get(`/${platformId}/storage-library`, { params });
        },

        /**
         * Get storage library items by parent.
         *
         * @param  {object}  params
         * @return {object}
         */
        findAllByParent(platformId, parentId, params = {}) {
            return requester.get(`/${platformId}/storage-library/${parentId}/children`, { params });
        },

        /**
         * Get storage library item.
         *
         * @param  {object}  params
         * @return {object}
         */
        findOne(platformId, id, params = {}) {
            return requester.get(`/${platformId}/storage-library/${id}`, { params });
        },

        /**
         * Create storage library item.
         *
         * @param  {object}  params
         * @return {object}
         */
        create(platformId, payload = {}) {
            return requester.post(`/${platformId}/storage-library`, payload);
        },

        /**
         * Update storage library item.
         *
         * @param  {object}  params
         * @return {object}
         */
        update(platformId, id, payload = {}) {
            return requester.put(`/${platformId}/storage-library/${id}`, payload);
        },

        /**
         * Delete storage library item.
         *
         * @param  {object}  params 
         * @return {object}
         */
        delete(platformId, id) {
            return requester.delete(`/${platformId}/storage-library/${id}`);
        },

        /**
         * Run operation on storage library item.
         *
         * @param  {object}  params
         * @return {object}
         */
        runOperation(platformId, id, payload = {}) {
            return requester.patch(`/${platformId}/storage-library/${id}`, payload);
        },  
    };
}
